import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { FiUpload, FiX, FiImage, FiVideo } from 'react-icons/fi';
import './InstallationMaharashtra.css';

const InstallationMaharashtra = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { farmerDetails, empId,selectedState } = location.state || {};

  // State for all photo categories
  const [borePhoto, setBorePhoto] = useState([]);
  const [pitPhoto, setPitPhoto] = useState([]);
  const [earthingFarmerPhoto, setEarthingFarmerPhoto] = useState([]);
  const [antiTheftNutBoltPhoto, setAntiTheftNutBoltPhoto] = useState([]);
  const [lightingArresterInstallationPhoto, setLightingArresterInstallationPhoto] = useState([]);
  const [controllerBoxFarmerPhoto, setControllerBoxFarmerPhoto] = useState([]);
  const [finalFoundationFarmerPhoto, setFinalFoundationFarmerPhoto] = useState([]);
  const [panelFarmerPhoto, setPanelFarmerPhoto] = useState([]);
  const [waterDischargeFarmerPhoto, setWaterDischargeFarmerPhoto] = useState([]);
  const [installationVideo, setInstallationVideo] = useState(null); // New state for video
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const { register, handleSubmit, formState: { errors } } = useForm();

  // Handle file upload (both single and multiple)
  const handlePhotoUpload = (e, setPhotoFunction) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setPhotoFunction(prev => [...prev, ...files]);
    }
    e.target.value = null;
  };

  // Handle video upload
  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setInstallationVideo(file);
    }
    e.target.value = null;
  };

  // Remove photo from preview
  const removePhoto = (index, photos, setPhotoFunction) => {
    const updatedPhotos = [...photos];
    updatedPhotos.splice(index, 1);
    setPhotoFunction(updatedPhotos);
  };

  // Remove video
  const removeVideo = () => {
    setInstallationVideo(null);
  };

  // Format file size for display
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Form submission handler
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmitError('');

    // const requiredFields = [
    //   { name: 'Bore Photo', photos: borePhoto },
    //   { name: 'Pit Photo', photos: pitPhoto },
    //   { name: 'Earthing Photo', photos: earthingFarmerPhoto },
    //   { name: 'Anti Theft Nut Bolt Photo', photos: antiTheftNutBoltPhoto },
    //   { name: 'Lighting Arrester Photo', photos: lightingArresterInstallationPhoto },
    //   { name: 'Controller Box Photo', photos: controllerBoxFarmerPhoto },
    //   { name: 'Final Foundation Photo', photos: finalFoundationFarmerPhoto },
    //   { name: 'Panel Photo', photos: panelFarmerPhoto },
    //   { name: 'Water Discharge Photo', photos: waterDischargeFarmerPhoto }
    // ];

    // const missingFields = requiredFields.filter(field => field.photos.length === 0);
    // if (missingFields.length > 0) {
    //   setSubmitError(`Please upload at least one photo for: ${missingFields.map(f => f.name).join(', ')}`);
    //   setIsSubmitting(false);
    //   return;
    // }

    const formData = new FormData();
    
    // Append form data
    formData.append('latitude', data.latitude);
    formData.append('longitude', data.longitude);
    formData.append('empId', empId);
    formData.append('farmerSaralId', farmerDetails.saralId);
    formData.append('state', selectedState);

    // Append all photos
    borePhoto.forEach(file => formData.append('borePhoto', file));
    pitPhoto.forEach(file => formData.append('pitPhoto', file));
    earthingFarmerPhoto.forEach(file => formData.append('earthingFarmerPhoto', file));
    antiTheftNutBoltPhoto.forEach(file => formData.append('antiTheftNutBoltPhoto', file));
    lightingArresterInstallationPhoto.forEach(file => formData.append('lightingArresterInstallationPhoto', file));
    controllerBoxFarmerPhoto.forEach(file => formData.append('controllerBoxFarmerPhoto', file));
    finalFoundationFarmerPhoto.forEach(file => formData.append('finalFoundationFarmerPhoto', file));
    panelFarmerPhoto.forEach(file => formData.append('panelFarmerPhoto', file));
    waterDischargeFarmerPhoto.forEach(file => formData.append('waterDischargeFarmerPhoto', file));

    // Append video if exists
    if (installationVideo) {
      formData.append('installationVideo', installationVideo);
    }

    console.log("Before submitting: ", formData)

    try {
      const response = await axios.post(
        `https://service.galosolar.com/api/external/forwardInstallationToHttp`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      console.log("after submit data: ", response.data)

      if (response.data.success) {
        alert('Installation submitted successfully!');
        navigate('/ApprovedDataMaharastra', { state: { message: 'Installation submitted successfully!' } });
      } else {
        setSubmitError(response.data.message || 'Failed to submit installation');
      }
    } catch (error) {
      setSubmitError(error.response?.data?.message || 'Network error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reusable photo upload component
  const PhotoUploadSection = ({ label, photos, setPhotos }) => {
    return (
      <div className="photo-upload-group">
        <label className="photo-upload-label">
          {label}
          <div className="upload-container">
            <label className="upload-button">
              <FiUpload className="upload-icon" />
              <span className='textcolor'>Upload Photos</span>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => handlePhotoUpload(e, setPhotos)}
                className="photo-upload-input"
              />
            </label>
           
          </div>
          
          {photos.length > 0 && (
            <div className="photo-preview-container">
              {photos.map((file, index) => (
                <div key={index} className="photo-preview-item">
                  <div className="image-preview">
                    {file.type.startsWith('image/') ? (
                      <img 
                        src={URL.createObjectURL(file)} 
                        alt="Preview" 
                        className="image-thumbnail"
                      />
                    ) : (
                      <div className="file-preview">
                        <FiImage className="file-icon" />
                        <span className="file-name">{file.name}</span>
                      </div>
                    )}
                  </div>
                  <div className="photo-info">
                    <span className="photo-index">#{index + 1}</span>
                    <span className="photo-size">{formatFileSize(file.size)}</span>
                  </div>
                  <button 
                    type="button" 
                    onClick={() => removePhoto(index, photos, setPhotos)}
                    className="remove-photo-btn"
                  >
                    <FiX />
                  </button>
                </div>
              ))}
            </div>
          )}
        </label>
      </div>
    );
  };

  return (
    <div className="installation-container">
      <h2 className="installation-header">Installation Details</h2>
      
      <div className="scrollable-content">
        <div className="farmer-details">
          <div>
            <span className="detail-label">Farmer Name:</span>
            <span className="detail-value">{farmerDetails?.farmerName || 'N/A'}</span>
          </div>
          <div>
            <span className="detail-label">Contact Number:</span>
            <span className="detail-value">{farmerDetails?.contact || 'N/A'}</span>
          </div>
          <div>
            <span className="detail-label">Saral ID:</span>
            <span className="detail-value">{farmerDetails?.saralId || 'N/A'}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="installation-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="latitude">
                Latitude<span className="required">*</span>
              </label>
              <input
                id="latitude"
                type="text"
                className={errors.latitude ? 'error' : ''}
                placeholder="e.g. 19.0760"
                {...register('latitude', { 
                  required: 'Latitude is required',
                  pattern: {
                    value: /^-?([1-8]?[0-9]\.\d+|90(\.0+)?)$/,
                    message: 'Invalid latitude value (-90 to 90)'
                  }
                })}
              />
              {errors.latitude && <p className="error-message">{errors.latitude.message}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="longitude">
                Longitude<span className="required">*</span>
              </label>
              <input
                id="longitude"
                type="text"
                className={errors.longitude ? 'error' : ''}
                placeholder="e.g. 72.8777"
                {...register('longitude', { 
                  required: 'Longitude is required',
                  pattern: {
                    value: /^-?((1[0-7]|[1-9])?[0-9]\.\d+|180(\.0+)?)$/,
                    message: 'Invalid longitude value (-180 to 180)'
                  }
                })}
              />
              {errors.longitude && <p className="error-message">{errors.longitude.message}</p>}
            </div>
          </div>

          <div className="photo-upload-section">
            <h3>Installation Photos (At least one required for each)</h3>
            
            <PhotoUploadSection label="Bore Photo (Only For Haryana)" photos={borePhoto} setPhotos={setBorePhoto} />
            <PhotoUploadSection label="Pit Photo" photos={pitPhoto} setPhotos={setPitPhoto} />
            <PhotoUploadSection label="Earthing with Farmer Photo" photos={earthingFarmerPhoto} setPhotos={setEarthingFarmerPhoto} />
            <PhotoUploadSection label="Anti Theft Nut Bolt Photo" photos={antiTheftNutBoltPhoto} setPhotos={setAntiTheftNutBoltPhoto} />
            <PhotoUploadSection label="Lighting Arrester Installation Photo" photos={lightingArresterInstallationPhoto} setPhotos={setLightingArresterInstallationPhoto} />
            <PhotoUploadSection label="Controller Box with Farmer Photo" photos={controllerBoxFarmerPhoto} setPhotos={setControllerBoxFarmerPhoto} />
            <PhotoUploadSection label="Final Foundation with Farmer Photo" photos={finalFoundationFarmerPhoto} setPhotos={setFinalFoundationFarmerPhoto} />
            <PhotoUploadSection label="Panel with Farmer Photo" photos={panelFarmerPhoto} setPhotos={setPanelFarmerPhoto} />
            <PhotoUploadSection label="Water Discharge with Farmer Photo" photos={waterDischargeFarmerPhoto} setPhotos={setWaterDischargeFarmerPhoto} />

            {/* New Video Upload Section */}
            <div className="photo-upload-group">
              <label className="photo-upload-label">
                Installation Video (Optional)
                <div className="upload-container">
                  <label className="upload-button">
                    <FiUpload className="upload-icon" />
                    <span className='textcolor'>Upload Video</span>
                    <input
                      type="file"
                      accept="video/*"
                      onChange={handleVideoUpload}
                      className="photo-upload-input"
                    />
                  </label>
                </div>
                
                {installationVideo && (
                  <div className="photo-preview-container">
                    <div className="photo-preview-item">
                      <div className="image-preview">
                        <div className="file-preview">
                          <FiVideo className="file-icon" />
                          <span className="file-name">{installationVideo.name}</span>
                        </div>
                      </div>
                      <div className="photo-info">
                        <span className="photo-size">{formatFileSize(installationVideo.size)}</span>
                      </div>
                      <button 
                        type="button" 
                        onClick={removeVideo}
                        className="remove-photo-btn"
                      >
                        <FiX />
                      </button>
                    </div>
                  </div>
                )}
              </label>
            </div>
          </div>

          {submitError && <div className="submit-error">{submitError}</div>}

          <div className="form-actions">
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Submitting...
                </>
              ) : (
                'Submit Installation Details'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InstallationMaharashtra;